// import loadPictures from './k1-load-picture';

/***
 * Кнопка новостей "показать еще" без перезагрузки
 */
function loadMore() {
	let currentPagination = document.querySelector('#pagination-container');
	let currentItemsList = document.querySelector('.articles-list');
	let nextPageURL = document.querySelector('.bx-pagination-container ul li.bx-pag-next a').getAttribute('href');
	fetch(nextPageURL, {
		method: 'post',
		headers: {
			'Content-Type': 'application/json'
		}
	}).then(response => {
		return response.text()
	}).then(data => {
		let parser = new DOMParser();
		let newDOM = parser.parseFromString(data, 'text/html');
		let newPagination = newDOM.querySelector('#pagination-container');
		let newItems = newDOM.querySelectorAll('.articles-item');
		let defLoadPictures = newDOM.querySelectorAll('.def-load-picture');
		newItems.forEach(item => {
			currentItemsList.append(item);
		});
		currentPagination.innerHTML = newPagination.innerHTML;
		window.k1ScriptDefault.loadPictures([...defLoadPictures]);
	})
	
}

window.addEventListener('click', function (e) {
	if (e.target.closest('.more-items-js')) {
		e.preventDefault();
		loadMore(e.target);
	}
});